// Flatten a `{ countryCode, callingCode, contact }` phone object: US numbers
// collapse to the bare contact string, non-US numbers move to the paired
// international key. Already-flattened string values are left untouched.
function switchPhoneField(data, phoneKey, internationalKey) {
  const phone = data[phoneKey];
  if (!phone || typeof phone !== 'object') {
    return data;
  }
  if (phone.countryCode === 'US') {
    return { ...data, [phoneKey]: phone.contact };
  }
  const callingCode = phone.callingCode || '';
  const contact = phone.contact || '';
  const result = { ...data };
  delete result[phoneKey];
  result[internationalKey] = `+${callingCode}-${contact}`;
  return result;
}

export function switchToInternationalPhone(formData) {
  let transformedValue = JSON.parse(formData);
  transformedValue = switchPhoneField(
    transformedValue,
    'claimantPhone',
    'claimantInternationalPhone',
  );
  transformedValue = switchPhoneField(
    transformedValue,
    'filingCustodianPhone',
    'filingCustodianInternationalPhone',
  );
  return JSON.stringify(transformedValue);
}
